import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	Popover,
	MenuItem,
	Zoom,
} from '@mui/material';
import { Button, ToggleSwitch, Tooltip } from 'flowbite-react';
import classNames from 'classnames';
import { Checkbox } from 'flowbite-react';
import { LeadData, Status, UserRole } from 'types';
import { MdOutlineEmail } from "react-icons/md";
import { PiPhoneDuotone } from "react-icons/pi";
import dayjs from 'dayjs';
import AssignCompanyModal from './AssignCompanyModal';
import { useAddLog } from 'src/hooks/leadGen.hooks';
import { useQueryClient } from 'react-query';
import { useToast } from 'src/context/ToastProvider';
import ViewLogModal from './ViewLogModal';
import { IoChevronDown } from 'react-icons/io5';
import AddLogModal from './AddLogModal';
import { useThemeContext } from 'src/context/ThemeProvider';
import IsArchivedModal from './IsArchivedModal';
import ReassignLeadGenPOCModal from './ReassignLeadGenPOCModal';
import { useUserContext } from 'src/context/UserProvider';
import AlternativeContactDetailsModal from './AlternativeContactDetailsModal';

interface Props {
	data: LeadData[];
	page: number;
	totalCount?: number;
	rowsPerPage?: number;
	showBulkSelectAction?: boolean;
	setRowsPerPage: (rowsPerPage: number) => void;
	setPage: React.Dispatch<React.SetStateAction<number>>;
	onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
	count?: number;
	myBDPOCsData: any;
	refetch: () => void;
	role: string;
	onSelectAllCandidates?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	bulkSelectedIds: string[];
	setBulkSelectedIds: Dispatch<SetStateAction<string[]>>;
	setOpenAddLogModal: React.Dispatch<React.SetStateAction<boolean>>;
	setIsReassignLeadGenPOCModal: React.Dispatch<React.SetStateAction<boolean>>;
	openAddLogModal: boolean;
	isReassignLeadGenPOCModal: boolean
}


export const getBgColor = (statusData?: Status | 'NA') => {
	if (statusData === Status.New) {
		return 'bg-purple-100 text-[#EDEBFE]';
	}
	if (statusData === Status.NotConnected) {
		return 'bg-red-100 text-[#FDE8E8]';
	}
	if (statusData === Status.DNP) {
		return 'bg-yellow-100 text-[#FDF6B2]';
	}
	if (statusData === Status.Positive) {
		return 'bg-green-100 text-[#DEF7EC]';
	}
	if (statusData === Status.FutureProspect) {
		return 'bg-green-100 text-[#DEF7EC]';
	}
	if (statusData === Status.Qualified) {
		return 'bg-purple-100 text-[#EDEBFE]';
	}
	if (statusData === Status.Unqualified) {
		return 'bg-red-100 text-[#FDE8E8]';
	}
	// if (statusData === Status.Onboarded) {
	// 	return 'bg-green-100 text-[#FDE8E8]';
	// }
	// if (statusData === Status.ProcessStart) {
	// 	return 'bg-green-100 text-[#FDE8E8]';
	// }
	if (statusData === Status.NotHiring) {
		return 'bg-red-100 text-[#FDE8E8]';
	}
	return '';
};
const AMLeadGenPocContainer: React.FC<Props> = ({
	data,
	page,
	totalCount,
	rowsPerPage = 10,
	setPage,
	showBulkSelectAction,
	setRowsPerPage,
	onPageChange = () => { },
	myBDPOCsData,
	refetch,
	role,
	onSelectAllCandidates,
	bulkSelectedIds,
	setBulkSelectedIds,
	setOpenAddLogModal,
	setIsReassignLeadGenPOCModal,
	openAddLogModal,
	isReassignLeadGenPOCModal
}) => {
	const queryClient = useQueryClient();
	const toast = useToast();
	const { themeMode } = useThemeContext();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalContent, setModalContent] = useState('');
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	// const [openAddLogModal, setOpenAddLogModal] = useState(false);
	const [openAssignCompanyModal, setOpenAssignCompanyModal] = useState(false);
	const [logNotes, setLogNotes] = useState('');
	const [companyDetails, setCompanyDetails] = useState({ companyName: '', leadGen: '', jobPostingLink: "" });
	const [viewLogCompanyDetails, setViewLogCompanyDetails] = useState({ companyName: '', name: '', email: '', phone: 0 });
	const [leadGen, setleadGen] = useState<string>("");
	const [selectedCallLogStatus, setSelectedCallLogStatus] = useState<string | undefined>(undefined);
	const [selectedStatus, setSelectedStatus] = useState<string | undefined>(undefined);
	const [selectedleadGen, setSelectedleadGen] = useState<string | undefined>(undefined);
	const [selectedData, setSelectedData] = useState<LeadData | undefined>(undefined);
	const [openIndex, setOpenIndex] = useState<number | null>(null);
	const [isArchivedModal, setIsArchivedModal] = useState<boolean>(false);
	const [selectedDate, setSelectedDate] = useState<Date | null>(null);
	const { bulkSelectIds, setBulkSelectIds } = useUserContext();
	const [isAllSelected, setIsAllSelected] = useState(false);
	const [showAltModal, setShowAltModal] = useState(false);
	const [altContactData, setAltContactData] = useState<LeadData | null>(null);


	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;
	const { mutate: addLogApi, isLoading } = useAddLog(
		data => {
			toast({ title: 'Add Log Successfully', type: 'success' });
			setOpenAddLogModal(false);
			setLogNotes('');
			setSelectedStatus(undefined);
			setSelectedDate(null)
			queryClient.invalidateQueries('addLog');
		},
		error => {
			toast({ title: 'Error creating add log', type: 'error' });
			console.error('Error creating lead:', error);
		},
	);

	const [maxLength, setMaxLength] = useState<number>(15);

	useEffect(() => {
		if (window.innerWidth < 960) {
			setMaxLength(20);
		} else {
			setMaxLength(25);
		}
	}, []);

	const handleAddLog = (leadGen: string) => {
		setSelectedleadGen(leadGen);
		setOpenAddLogModal(true);
	};

	const handleViewLog = (company_Name: string, name: string, email: string, phone: number) => {
		setViewLogCompanyDetails({ companyName: company_Name, name, email, phone });
		setIsDrawerOpen(true);
	};

	const handleAssignBDPOC = (company_Name: string, id: string, jobPostingLink: string) => {
		setCompanyDetails({ companyName: company_Name, leadGen: id, jobPostingLink: jobPostingLink });
		setOpenAssignCompanyModal(true);
	};

	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	const handleCloseDrawer = () => {
		setIsDrawerOpen(false);
	};

	const isArchivedLeadGen = (id: string) => {
		setleadGen(id);
		setIsArchivedModal(true);
	};

	const handleReassignLeadGenPOC = (leadGen: string, selectedData: LeadData) => {
		setSelectedleadGen(leadGen);
		setSelectedData(selectedData);
		setIsReassignLeadGenPOCModal(true);
	};

	const addLog = [
		{
			label: 'Add Log', value: 'Add Log', action: handleAddLog, hide: false,
		},
		{ label: 'View Log', value: 'View Log', action: handleViewLog, hide: false },
		{ label: 'Assign BD POC', value: 'Assign BD POC', action: handleAssignBDPOC, hide: selectedData?.status === 'Unqualified' ? true : false },
		{ label: 'Reassign Lead Gen POC', value: 'Reassign Lead Gen POC', action: handleReassignLeadGenPOC, hide: false },
		{ label: 'Close Lead', value: 'Close Lead', action: isArchivedLeadGen, hide: false }
	];

	const columns = ['Contact', 'Company', 'Source', 'Lead Gen POC', 'Status', 'Assigned to Lead Gen', 'Assigned to BD', 'Last Remark']


	const handleAddLogSubmit = async () => {
		try {
			const payload = {
				callLogsStatus: selectedCallLogStatus,
				status: selectedStatus,
				selectedDate: selectedDate,
				remarks: logNotes,
			};

			const ids = bulkSelectedIds.length > 0 ? bulkSelectedIds : [selectedleadGen].filter(Boolean);

			if (ids.length > 0) {
				await addLogApi(
					{ ids, data: payload },
					{
						onSuccess: () => {
							setOpenAddLogModal(false);
							setLogNotes('');
							setSelectedStatus(undefined);
							refetch();
						},
					}
				);
			} else {
				setOpenAddLogModal(false);
			}
		} catch (error) {
			console.error('Error creating lead:', error);
		}
	};
	const handleClick = (event: React.MouseEvent<HTMLElement>, data: LeadData, index: number) => {
		setAnchorEl(event.currentTarget);
		setSelectedleadGen(data?._id);
		setSelectedData(data)
		setOpenIndex(index);
	};

	const handleClose = () => {
		setAnchorEl(null);
		setOpenIndex(null);
	};

	const handleChangePage = (event: unknown, newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleSelectAllCandidates = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			const pageIds = data.map(candidate => candidate._id).filter((id): id is string => id !== undefined);
			setBulkSelectedIds(prevIds => Array.from(new Set([...prevIds, ...pageIds])));
		} else {
			const pageIds = data.map(candidate => candidate._id).filter((id): id is string => id !== undefined);
			setBulkSelectedIds(prevIds => prevIds.filter(id => !pageIds.includes(id)));
		}
	};

	const toggleSelection = (id: string) => {
		setBulkSelectedIds(prev => {
			if (prev.includes(id)) {
				return prev.filter(prevId => prevId !== id);
			} else {
				return [...prev, id];
			}
		});
	};
	const handleShowAlternatives = (row: LeadData) => {
		setAltContactData(row);
		setShowAltModal(true);
	};
	useEffect(() => {
		const isPageAllSelected = data.every(candidate => bulkSelectedIds.includes(candidate._id ?? ''));
		setIsAllSelected(isPageAllSelected);
	}, [bulkSelectedIds, data]);
	return (
		<>
			<div className="flex max-w-[1440px] mx-auto">
				<div className="w-full">
					<Paper
						sx={{
							width: '100%',
							overflow: 'hidden',
							borderRadius: '8px',
							isolation: 'isolate',
							boxShadow: '0px 1px 2px -1px rgba(0, 0, 0, 0.10), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)',
							'&>MuiTableContainer-root': {
								scrollbarWidth: 'auto !important',
							},
						}}
					>
						<TableContainer
							sx={{
								minHeight: 'auto',
								'::-webkit-scrollbar': {
									width: '100px !important',
									display: 'block !important',
									height: '2px !important',
								},
								'::-webkit-scrollbar-thumb': {
									backgroundColor: '#555770 !important',
									borderRadius: '10px !important',
								},
								'::-webkit-scrollbar-track': {
									backgroundColor: '#f5f5f5 !important',
								},
								scrollbarWidth: 'auto !important',
							}}
						>
							<Table aria-label="sticky table">
								<TableHead sx={{ position: 'sticky', top: 0, zIndex: 1, whiteSpace: 'pre' }}>
									<TableRow
										sx={{
											'&': {
												background: '#F2F2F5',
												'[data-mode="dark"] &': {
													background: '#18222D',
												},
											},
										}}
									>
										<Zoom in={showBulkSelectAction} mountOnEnter unmountOnExit>
											<TableCell align="center" padding="checkbox">
												<Checkbox
													color="purplePlaced"
													checked={data.every(candidate => bulkSelectedIds.includes(candidate._id ?? ''))}
													onChange={handleSelectAllCandidates}
												/>
											</TableCell>
										</Zoom>
										{columns.map((header, index) => (
											<TableCell key={index}>
												<span className="font-inter text-[14px] font-medium leading-[20px] uppercase">
													{header}
												</span>
											</TableCell>
										))}
										<TableCell style={{ position: 'sticky', right: 0, zIndex: 2, background: '#F2F2F5' }}><b>Actions</b></TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{data.length === 0 ? (
										<TableRow>
											<TableCell colSpan={12} align="center">
												<div className="flex items-center flex-col justify-center py-8">
													<img src="/assets/emptyStates/notFound.svg" alt="not-found" />
													<p className="text-gray-500 text-lg font-semibold mt-2">No Logs Found</p>
													<p className="text-gray-500 text-sm font-normal">Please upload a CSV file to create leads.</p>
												</div>
											</TableCell>
										</TableRow>
									) : (
										data.map((rowData, index) => {
											return (
												<TableRow key={rowData?._id} sx={{ whiteSpace: 'nowrap' }}>
													<Zoom in={showBulkSelectAction} mountOnEnter unmountOnExit>
														<TableCell align="center" padding="checkbox">
															<Checkbox
																color="purplePlaced"
																checked={rowData._id ? bulkSelectedIds.includes(rowData._id) : false}
																onClick={e => {
																	e.stopPropagation();
																	if (rowData?._id) {
																		toggleSelection(rowData?._id);
																	}
																}}
															/>
														</TableCell>
													</Zoom>
													<TableCell>
														<div className="flex flex-col gap-1">
															<span
																className="font-inter text-[18px] font-semibold leading-[120%]"
															>
																{rowData?.name || ''}
															</span>
															<div className="flex flex-row items-center gap-1" >
																<MdOutlineEmail className="" />
																<span className="font-inter text-[14px] font-medium leading-[20px]"
																>
																	{rowData?.email || ''}
																</span>
															</div>
															<div className="flex items-center gap-1">
																<PiPhoneDuotone className="" />
																<span
																	className="font-inter text-[14px] font-medium leading-[20px]"
																>
																	{rowData?.phone || ''}
																</span>
															</div>
															{(rowData?.alternativeName1 || rowData?.alternativeEmail1 || rowData?.alternativePhone1 ||
																rowData?.alternativeName2 || rowData?.alternativeEmail2 || rowData?.alternativePhone2) && (
																	<Button
																		size="xs"
																		color="light"
																		className="mt-1 w-fit"
																		onClick={() => handleShowAlternatives(rowData)}
																	>
																		Alternative Details
																	</Button>
															)}
														</div>
													</TableCell>
													<TableCell className='text-[#555770]'>{rowData?.sourceCompanyName || ''}</TableCell>
													<TableCell>
														<div className="flex flex-col">
															<span>{rowData?.source || ''}</span>
															<a
																href={rowData?.jobPostingLink || '#'}
																target="_blank"
																rel="noopener noreferrer"
																onClick={(e) => e.stopPropagation()}
																className="text-[#3E7BFA] underline decoration-solid decoration-[1px] underline-offset-2"
															>
																Job link
															</a>
														</div>
													</TableCell>
													<TableCell>{rowData?.leadGenPOC || ''}</TableCell>
													<TableCell>
														<span className={classNames(
															'self-stretch rounded-[6px] py-[2px] px-[10px] text-[12px] font-medium break-words leading-[18px] font-inter !text-[#723B13]',
															getBgColor(rowData?.status ? rowData.status as Status : Status.New),
														)}>{rowData?.status ? rowData.status : Status.New}</span></TableCell>
													<TableCell className='text-[#555770] font-[500]'>
														<span className='text-[16px] '>{dayjs(rowData?.createdAt).format('DD MMM YYYY h:mm A')}</span>
													</TableCell>
													<TableCell className='text-[#555770] font-[500]'>
														<div className='flex flex-col gap-1 '>
															<span className=''>
																{rowData?.bdPOC ? rowData.bdPOC : '--'}
															</span>
															<span className='size-[8px] font-[500] text-[#555770]'>
																{rowData?.bdAssignDate ? dayjs(rowData.bdAssignDate).format('DD MMM YYYY h:mm A') : ''}
															</span>
														</div>
													</TableCell>
													<TableCell className='text-[#555770] font-[500]'>
														{rowData?.callLogHistory?.length ?? 0 > 0 ? (
															<div className='flex flex-col gap-1'>
																<div className="flex justify-start">
																	<span className='rounded-[6px] py-[2px] px-[10px] text-[12px] font-medium break-words leading-[18px] font-inter text-[#5521B5] bg-[#EDEBFE]'>{rowData?.callLogHistory?.[rowData.callLogHistory.length - 1].callLogsStatus || '--'}</span>
																</div>
																<span>
																	{rowData?.callLogHistory && rowData.callLogHistory[rowData.callLogHistory.length - 1]?.remarks?.length > maxLength ? (
																		<>
																			<Tooltip
																				onClick={e => {
																					e.stopPropagation();
																				}}
																				content={rowData?.callLogHistory?.[rowData.callLogHistory.length - 1]?.remarks}
																			>
																				<span
																					onClick={e => {
																						e.stopPropagation();
																					}}
																				>
																					{rowData?.callLogHistory?.[rowData.callLogHistory.length - 1]?.remarks.substring(0, maxLength)}...
																				</span>
																			</Tooltip>
																		</>
																	) : (
																		<>{rowData?.callLogHistory?.[rowData.callLogHistory.length - 1]?.remarks || '--'}</>
																	)}
																</span>
																<span>
																	{
																		rowData?.callLogHistory && rowData.callLogHistory[rowData.callLogHistory.length - 1]?.
																			updatedAt ? dayjs(rowData.callLogHistory[rowData.callLogHistory.length - 1].
																				updatedAt).format('DD MMM YYYY h:mm A') : '--'}
																</span>
															</div>
														) :
															<span>--</span>
														}
													</TableCell>
													<TableCell
														key={index}
														className="uppercase text-[#1F3343] font-inter font-[500] text-sm bg-white"
														style={{
															position: 'sticky',
															right: 0,
															zIndex: 2,
														}}
													>
														<div className='relative'>
															<Button color="purplePlaced" className="ml-auto [&_span]:!p-0 !p-0 border-[#E5E7EB]">
																<p
																	className="px-[10px] py-[8px]"
																	onClick={(event) => rowData._id && handleClick(event, rowData, index)}
																>
																	Add Log
																</p>
																<span
																	aria-haspopup="true"
																	aria-describedby={id}
																	aria-expanded={open ? 'true' : undefined}
																	onClick={(event) => rowData._id && handleClick(event, rowData, index)}
																	className="border-l border-[#E5E7EB]"
																>
																	<IoChevronDown
																		className={classNames('w-[34px] h-[34px] px-[8px] transition-transform', openIndex === index ? 'rotate-[180deg]' : '')}
																	/>
																</span>

																<Popover
																	open={open}
																	anchorEl={anchorEl}
																	onClose={handleClose}
																	anchorOrigin={{
																		vertical: 'bottom',
																		horizontal: 'right',
																	}}
																	transformOrigin={{
																		vertical: 'top',
																		horizontal: 'right',
																	}}
																	onClickCapture={() => {
																		handleClose();
																	}}
																	sx={{
																		'&>.MuiPaper-root': {
																			borderRadius: '8px',
																			background: themeMode === 'dark' ? '#18222D' : 'white',
																			boxShadow: '0px 1px 2px -1px rgba(0, 0, 0, 0.10), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)',
																		},
																		'&>.MuiPaper-root>.MuiButtonBase-root': {
																			minHeight: '40px',
																		},
																	}}
																>
																	{addLog?.map((item) => {
																		if (role !== UserRole.SUPER_LEAD_GEN && (item.value === 'Close Lead' || item.value === 'Reassign Lead Gen POC')) {
																			return null;
																		}
																		return (
																			<MenuItem
																				key={item.value}
																				className={'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50]'}
																				disabled={item.hide}
																				onClick={() => {
																					handleClose();
																					switch (item.value) {
																						case 'Add Log':
																							if (selectedleadGen) {
																								(item.action as (id: string) => void)(selectedleadGen);
																							}
																							break;
																						case 'View Log':
																							if (selectedleadGen) {
																								(item.action as (company_Name: string, name: string, email: string, phone: number) => void)(rowData.sourceCompanyName, rowData.name, rowData.email, Number(rowData.phone));
																							}
																							break;
																						case 'Assign BD POC':
																							if (selectedData?.sourceCompanyName && selectedleadGen) {
																								(item.action as (company_Name: string, id: string, jobPostingLink: string) => void)(
																									selectedData?.sourceCompanyName || '',
																									selectedleadGen,
																									selectedData?.jobPostingLink || ''
																								);
																							}
																							break;
																						case 'Reassign Lead Gen POC':
																							if (selectedleadGen && selectedData) {
																								(item.action as (id: string, selectedData: string) => void)(
																									selectedleadGen,
																									selectedData?.leadGenPOC || ''
																								);
																							}
																							break;
																						case 'Close Lead':
																							if (selectedleadGen) {
																								(item.action as (id: string) => void)(
																									selectedleadGen
																								);
																							}
																							break;
																						default:
																							break;
																					}
																				}}
																			>
																				{item.label}
																			</MenuItem>
																		)
																	})}

																</Popover>
															</Button>
														</div>
													</TableCell>
												</TableRow>
											)
										})
									)}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							sx={{
								'&': {
									background: '#FAFAFC',
									'[data-mode="dark"] &': {
										background: '#18222D',
									},
								},
							}}
							rowsPerPageOptions={[5, 10, 25, 100]}
							component="div"
							count={totalCount ?? 0}
							rowsPerPage={rowsPerPage}
							page={page}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
						/>
					</Paper>
				</div>
			</div>

			<AlternativeContactDetailsModal
				isOpen={showAltModal}
				onClose={() => setShowAltModal(false)}
				data={altContactData}
			/>
			<AddLogModal
				isOpen={openAddLogModal}
				onClose={() => setOpenAddLogModal(false)}
				logNotes={logNotes}
				setLogNotes={setLogNotes}
				selectedStatus={selectedStatus ?? ''}
				selectedDate={selectedDate}
				setSelectedDate={setSelectedDate}
				setSelectedStatus={setSelectedStatus}
				handleAddLogSubmit={handleAddLogSubmit}
				setOpenAddLogModal={setOpenAddLogModal}
				setSelectedCallLogStatus={setSelectedCallLogStatus}
				setModalContent={setModalContent}
				selectedCallLogStatus={selectedCallLogStatus || ''}
			/>

			<ReassignLeadGenPOCModal
				isOpen={isReassignLeadGenPOCModal}
				onClose={() => setIsReassignLeadGenPOCModal(false)}
				selectedleadGen={selectedleadGen ?? ''}
				selectedData={selectedData ?? {} as LeadData}
				refetch={refetch}
				setIsReassignLeadGenPOCModal={setIsReassignLeadGenPOCModal}
				bulkSelectedIds={bulkSelectedIds}
			/>

			<IsArchivedModal
				isOpen={isArchivedModal}
				onClose={() => setIsArchivedModal(false)}
				id={leadGen}
				refetch={refetch}
			/>

			{selectedData && (
				<ViewLogModal
					isOpen={isDrawerOpen}
					onClose={handleCloseDrawer}
					viewLogDetails={selectedData}
					refetch={refetch}
				/>
			)}

			<AssignCompanyModal
				isOpen={openAssignCompanyModal}
				onClose={() => setOpenAssignCompanyModal(false)}
				companyBaseInfo={companyDetails}
				myBDPOCsData={myBDPOCsData}
				refetch={refetch}
			/>
		</>
	);
};

export default AMLeadGenPocContainer;